/// <amd-module name="TFS/Token/PatTokenPage/Context/GlobalProvider" />
import { AccountNameProvider, IAccountNameProviderProps } from 'Context/AccountNameContext';
import { IPanelProviderProps, PanelProvider } from "Context/PanelContext";
import { IPatPageProviderProps, PatPageProvider } from "Context/PatPageContext";
import { ITokenProviderProps, TokenProvider } from "Context/TokenContext";
import { ITelemetryContextProps, TelemetryContext } from './TelemetryContext';
import * as React from "react";

export interface IGlobalProviderProps extends IPatPageProviderProps, ITokenProviderProps, IPanelProviderProps, IAccountNameProviderProps, ITelemetryContextProps { }

export const GlobalProvider: React.StatelessComponent<IGlobalProviderProps> = (props: IGlobalProviderProps & {
    children?: React.ReactNode;
}) => {
    return (
        <PatPageProvider {...props}>
            {/* All providers depend on PatPageProvider, due to the tendency of VssComponent pageContext implementation*/}
            <AccountNameProvider {...props}>
                <TokenProvider {...props}>
                    <PanelProvider {...props}>
                        {props.children}
                    </PanelProvider>
                </TokenProvider>
            </AccountNameProvider>
            <TelemetryContext />
        </PatPageProvider>
    );
}
